import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-950 text-slate-300">
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo inverted />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Vehicle and equipment transport from Tadcaster, North Yorkshire to
            every corner of the UK — with independent, FCA-regulated payment
            protection on every booking.
          </p>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-white">Pages</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link data-testid="footer-link-home" className="transition-colors hover:text-white" to="/">Home</Link></li>
            <li><Link data-testid="footer-link-payment-protection" className="transition-colors hover:text-white" to="/payment-protection">Payment Protection</Link></li>
            <li><Link data-testid="footer-link-about" className="transition-colors hover:text-white" to="/about">About</Link></li>
            <li><Link data-testid="footer-link-track" className="transition-colors hover:text-white" to="/track">Track Your Vehicle</Link></li>
            <li><Link data-testid="footer-link-contact" className="transition-colors hover:text-white" to="/contact">Contact &amp; Quotes</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-white">Services</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
            <li>Vehicle Transport</li>
            <li>Plant &amp; Machinery</li>
            <li>Caravan &amp; Boat Transport</li>
            <li>Enclosed Prestige Transport</li>
            <li>Commercial Fleet Movements</li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-white">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" />
              <span>Unit 2 Priory Farm, Featherbed Lane, Wighill Park, Tadcaster, England, LS24 8BN</span>
            </li>
            <li className="flex gap-2.5">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" />
              <a data-testid="footer-phone" href="tel:+447462227041" className="transition-colors hover:text-white">+44 7462 227041</a>
            </li>
            <li className="flex gap-2.5">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" />
              <a data-testid="footer-email" href="mailto:operations@solaris-transport-ltd.co.uk" className="break-all transition-colors hover:text-white">operations@solaris-transport-ltd.co.uk</a>
            </li>
            <li className="flex gap-2.5">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" />
              <span>Mon–Fri 9am–5pm · Sat 9am–2pm</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-slate-800 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center">
        <p data-testid="footer-copyright">© 2026 Solaris Transport LTD. All rights reserved.</p>
        <p className="font-mono tracking-wide">TADCASTER · UK-WIDE COVERAGE · <Link to="/admin/login" data-testid="footer-admin-link" className="transition-colors hover:text-white">ADMIN</Link></p>
      </div>
    </div>
  </footer>
);

export default Footer;
